import { FormattedMessage } from 'react-intl';
import { ReactNode, useMemo } from 'react';

import { useStyles } from './steps-list.styles';
import register from '../../../../../assets/images/referral-modal/register.svg';
import registered from '../../../../../assets/images/referral-modal/registered.svg';
import buy from '../../../../../assets/images/referral-modal/buy.svg';
import fit from '../../../../../assets/images/referral-modal/fitting.svg';
import { ListUnordered } from '../../../../common';
import { ListItem } from '../../../../common/list-unordered';
import { cx } from  '../../../../../utils';

interface ItemProps {
  icon: string;
  item: ReactNode;
}

const Item = ({ icon, item }: ItemProps): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      {icon && <img src={icon} alt="" aria-hidden className={classes.icon} />}
      {item}
    </>
  );
};

export const StepsList = ({ isRegistered }: { isRegistered: boolean }): JSX.Element => {
  const classes = useStyles();

  const reasons = useMemo((): ListItem[] => {
    return [
      {
        id: 'referral.modal.step-1',
        item: <Item item={<FormattedMessage id="referral.modal.step-1" />} icon={isRegistered ? registered : register} />,
      },
      {
        id: 'referral.modal.step-2',
        item: <Item item={<FormattedMessage id="referral.modal.step-2" />} icon={fit} />,
      },
      {
        id: 'referral.modal.step-3',
        item: <Item item={<FormattedMessage id="referral.modal.step-3" />} icon={buy} />,
      },
    ];
  }, [isRegistered]);

  return (
    <ListUnordered
      listStyles={cx(classes.list, { [classes.listNoRadius]: isRegistered })}
      items={reasons}
      listGap="gap-8"
      itemStyles={classes.item}
      testId="steps-list"
    />
  );
};
